import cl from "./PumpStation.module.css";
import Caption from "../caption/Caption";
import { useVariable } from "../../../hooks/useVariable";

const PumpStation = ({
  children,
  name,
  varName,
  maxLevel=4,
  left = 0,
  top = 0,
  class_name,
}) => {
  const classes = [cl.pumpStation, class_name];
  let waterLevel=useVariable(varName);
  let portion = 300*waterLevel/maxLevel;

   const [valueText, pumpGroup] = Array.isArray(children) ? children : [children, null];

  return (
    <div className={`${cl.pumpStation} ${class_name || ""}`}>
      <div className={cl.backWall} />
      <div className={cl.waterVolume} style={{ height: `${portion}px` }} />

      {/* Левый верх — шапка */}
      <div className={cl.overlayTL}>
        <Caption>{name}</Caption>
        {valueText}
      </div>

      {/* Низ — зона насосов */}
      <div className={cl.bottomZone}>
        {pumpGroup}
      </div>
    </div>
  );
};

export default PumpStation;
